import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-1 overflow-auto lg:overflow-visible pb-20 lg:pb-0" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 px-4" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-4 px-4" }
const _hoisted_4 = { class: "flex flex-row justify-end items-center mt-8 bg-gray-100 pr-2 py-2 absolute lg:relative bottom-0 left-0 w-full lg:w-auto rounded-b-lg" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Submit ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_Select = _resolveComponent("Select")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock(_component_Form, {
    valid: _ctx.valid,
    "onUpdate:valid": _cache[11] || (_cache[11] = $event => (_ctx.valid = $event))
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Input, {
            label: "Name",
            rules: _ctx.form.name.rules,
            value: _ctx.form.name.value,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => (_ctx.form.name.value = $event))
          }, null, 8, ["rules", "value"]),
          _createVNode(_component_Input, {
            label: "Amount",
            rules: _ctx.form.amount.rules,
            value: _ctx.form.amount.value,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => (_ctx.form.amount.value = $event))
          }, null, 8, ["rules", "value"]),
          _createVNode(_component_Select, {
            label: "Account Type",
            items: _ctx.types,
            "item-label": "name",
            "item-value": "id",
            rules: _ctx.form.type.rules,
            value: _ctx.form.type.value,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => (_ctx.form.type.value = $event))
          }, null, 8, ["items", "rules", "value"]),
          (!_ctx.editMode)
            ? _createVNode(_component_Select, {
                key: 0,
                label: "Due Date",
                items: _ctx.dates,
                rules: _ctx.form.due_date.rules,
                value: _ctx.form.due_date.value,
                "onUpdate:value": _cache[4] || (_cache[4] = $event => (_ctx.form.due_date.value = $event))
              }, null, 8, ["items", "rules", "value"])
            : _createCommentVNode("", true)
        ]),
        (_ctx.editMode)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_Checkbox, {
                class: "pl-4 my-6",
                label: "Calculate this purchase in your totals?",
                rules: _ctx.form.not_track_amount.rules,
                value: _ctx.form.not_track_amount.value,
                "onUpdate:value": _cache[5] || (_cache[5] = $event => (_ctx.form.not_track_amount.value = $event))
              }, null, 8, ["rules", "value"]),
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_Input, {
                  label: "Confirmation",
                  rules: _ctx.form.confirmation.rules,
                  value: _ctx.form.confirmation.value,
                  "onUpdate:value": _cache[6] || (_cache[6] = $event => (_ctx.form.confirmation.value = $event))
                }, null, 8, ["rules", "value"]),
                _createVNode(_component_DatePicker, {
                  label: "Paid Date",
                  rules: _ctx.form.paid_date.rules,
                  value: _ctx.form.paid_date.value,
                  "onUpdate:value": _cache[7] || (_cache[7] = $event => (_ctx.form.paid_date.value = $event))
                }, null, 8, ["rules", "value"])
              ]),
              _createVNode(_component_Textarea, {
                class: "px-4",
                label: "Notes",
                rules: _ctx.form.notes.rules,
                value: _ctx.form.notes.value,
                "onUpdate:value": _cache[8] || (_cache[8] = $event => (_ctx.form.notes.value = $event))
              }, null, 8, ["rules", "value"])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          "onOn-click": _cache[9] || (_cache[9] = $event => (_ctx.closeModal(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          "is-disabled": !_ctx.valid,
          color: "secondary",
          "onOn-click": _cache[10] || (_cache[10] = $event => (_ctx.closeModal(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["is-disabled"])
      ])
    ]),
    _: 1
  }, 8, ["valid"]))
}